import { createBrowserHistory } from "history";

const basename = "/app";
const historyObj = createBrowserHistory({ basename });

export default historyObj;
